import { FluidTheme } from '@lmig/fluid-core';

import { getDataAtPath } from '../../components/fluid-table/internal/fluid-table-data-management.utils';
import { corp } from './corp.variables';
import { legacy } from './legacy.variables';
import { lm } from './lm.variables';
import { portal } from './portal.variables';

export interface Themes {
  default: ThemeVariables;
  legacy: ThemeVariables;
  lm: ThemeVariables;
  corp: ThemeVariables;
  portal: ThemeVariables;
}

export interface ThemeVariables {
  [key: string]: any;
}

export const themes: Themes = {
  default: corp,
  legacy,
  lm,
  corp,
  portal,
};

export function themeVar<T>(
  theme: FluidTheme = FluidTheme.CORP,
  dataPath: string
): T {
  const themeVariables = themes[theme];
  return getDataAtPath(themeVariables, null, dataPath) as T;
}
